import React from 'react';

const Logo = () => {
    return (
        <div className= "logo">
            <img src="./img/logo.svg" alt="logo" />
        </div>
    );
};

export default Logo;